define('plugin/location/step/LocationStep',['require','lib/controller/booking/BaseStep','plugin/location/collection/LocationCollection','plugin/location/view/LocationStepView'],function (require) {

	var BaseStep = require('lib/controller/booking/BaseStep');
	var LocationCollection = require('plugin/location/collection/LocationCollection');
	var LocationStepView = require('plugin/location/view/LocationStepView');
	
	return BaseStep.extend({
		
		_step: 'location',
		_locationCollection: null,
		_skipStep: false,
		
		/**
		 * Inits instance, collection, subscribe to events
		 */
		initialize: function() {
	        BaseStep.prototype.initialize.call(this);
	        
	        this._locationCollection = this.getOption('collection');
	        this._locationCollection.fetch();

	        this.listenTo(this._bookingModel, 'change:location_id', this.updateInfo);
	        // perform filter performers after all data fetched from server (like services, locations, etc.)
			this.listenTo(this._stepManager, 'step:fetch', this.performCollectionFilters);
	        this.listenTo(this._locationCollection, 'sync', this.onDataFetch);
	    },

        /**
         * Triggers init event
         */
        triggerInit: function () {
            this.triggerStepEvent('init', [this, this._locationCollection]);
        },

	    /**
	     * Returns step view
	     * 
	     * @return LocationStepView
	     */
		getView: function () {
			return new LocationStepView({
	    		collection: this._locationCollection
	    	});
		},
		
		/**
		 * Calls when collection fetched from server
		 */
		onDataFetch: function () {
			this.triggerStepEvent('fetch');
			this.updateInfo();

			if (this._locationCollection.getDataCollection().isEmpty()) {
                // do not skip empty location step
                this._stepManager.showStep('location');
            } else if (this._locationCollection.getDataCollection().length == 1) {
				this._stepManager.hideStep('location');
			} else {
				this._stepManager.showStep('location');
			}

			this.done();
		},
		
		/**
		 * Updates booking info data
		 */
		updateInfo: function () {
			if(this._stepManager.isStepHidden('location') && this._locationCollection.length > 1){
				this._stepManager.showStep('location');
			}

            var locationId = this._bookingModel.get('location_id');
            var location = this._locationCollection.getModelObj(locationId);
            this._bookingModel.set('location', location);
	    },

		/**
		 * Calls before show view
		 */
		beforeViewShow: function () {
			this.performCollectionFilters();
		},

		/**
		 * Apply filters to collection before show step view
		 */
		performCollectionFilters: function () {
			this._locationCollection.performFilters();
		},

		_autoSelectItem: function () {
			this.setIsSkipped(false);
            
			if (this._locationCollection.length === 1) {
				this.setIsSkipped(true);
			}
            if (this._locationCollection._once_synced && this._locationCollection.isEmpty() && this._bookingModel.get('provider_id') && 
                (this._bookingModel.get('provider_id') != 'any' || this._bookingModel.get('service_id'))
            ) {
                //skip empty location step only if provider preselected (or if service selected, any_unit selected and )
                this.setIsSkipped(true);
            }

			if (this._bookingModel.get('location_id')) {
				return;
			}

			if (this.isStepSkipped()) {
				var current = this._locationCollection.first();
				if (current) {
					this._bookingModel.set('location_id', current.get('id'));
				} else {
                    this._stepManager.hideStep('location');
                }
			} else {
                this._stepManager.showStep('location');
            }
		},

	    /**
	     * Returns true if provider is selected
	     * 
	     * @return Boolean
	     */
	    isValid: function () {
			this.performCollectionFilters();
			this._autoSelectItem();
            
            var locationId = this._bookingModel.get('location_id');
            var location = this._locationCollection.getModelObj(locationId);
            if (locationId && this._locationCollection.length && !location) {
                setTimeout(function () {
                    Backbone.history.navigate('error/e404', {
                        trigger: true,
                        replace: true
                    });
                });
            }
            
			if(this._stepManager.isStepHidden('location')) {
				return true;
			}
			if (this._bookingModel.get('location_id')) {
				return true;
			}
            
			return false;
	    }
	    
	});
	
});
